import { render } from "./UpcomingEventsSliderSlide.vue?vue&type=template&id=e71ef9ae"
import script from "./UpcomingEventsSliderSlide.vue?vue&type=script&lang=js"
export * from "./UpcomingEventsSliderSlide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__